<template>
  <span v-if="!logoError && EnterpriseId">
      <img :src="logoUrl" title="学校logo" @error="()=>{ logoError=true; }" id="logo_common">
  </span>
  <span v-else>
      <img src="@/assets/images/logo.png" id="logo_common">
  </span>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      logoUrl:'',
      logoError:false
    };
  },
  props:{
    name:{
      type:String,
      default:()=>{
        return 'common';
      }
    }
  },
  watch:{
    EnterpriseId:{
      handler(val,oldval){
        if(val){
          this.logoUrl = `${location.origin}/infoplus/file/enterprise/${val}/icon/logo_${this.name}`;
        console.log(this.logoUrl);
        }
      },
      deep:true
    }
  },
  computed:{
    EnterpriseId(){
      if( this.$store.getters.getUserInfo.enterprise){
          return  this.$store.getters.getUserInfo.enterprise.id;
      }else{
          return '';
      }
    },
  },
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/todoCenter/logo.vue